(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('ApprovePaymentModalController', ApprovePaymentModalController);

    ApprovePaymentModalController.$inject = ['$uibModalInstance', '$scope', '$timeout', 'toastr','InvoicesService', 'invoice', 'invoiceList'];

    function ApprovePaymentModalController($uibModalInstance, $scope, $timeout, toastr, InvoicesService, invoice, invoiceList) {
        var vm = this;
        vm.invoice                  = invoice;
        vm.invoiceList              = invoiceList;
        vm.invoiceTotalRate         = invoice.total_rate;
        vm.invoiceTotalPaid         = 0;
        vm.invoicesPaymentsList     = [];
        vm.isAllSelected            = false;
        vm.getInvoicePaymentHistory = getInvoicePaymentHistory;
        vm.approve                  = approve;
        vm.disapprove               = disapprove;
        vm.cancel                   = cancel;
        vm.optionToggled            = optionToggled;
        vm.toggleAll                = toggleAll;

        activate();

        function activate() {
            vm.getInvoicePaymentHistory();
        }

        function getInvoicePaymentHistory() {
            vm.amountToBePaid = vm.invoice.total_calculated;
            if(vm.invoice.id) {
                InvoicesService.getInvoicePaymentHistory(vm.invoice.id).then(function (response) {
                    vm.invoicesPaymentsList = response.data;
                    vm.invoiceTotalPaid = vm.invoice.total_paid;
                    vm.difference = vm.invoice.total_calculated - vm.invoice.total_paid;
                    if(response.data[0]) {
                        vm.invoiceTotalPaid = response.data[0].amount_to_be_paid;
                        vm.difference = vm.invoice.total_calculated - response.data[0].amount_to_be_paid;
                    }
                }).catch(function (err) {
                });
            }
        }

        function optionToggled() {
            vm.isAllSelected = vm.invoicesPaymentsList.every(function(itm){ return itm.selected; })
        }

        function toggleAll() {
            var toggleStatus = vm.isAllSelected;
            angular.forEach(vm.invoicesPaymentsList, function(itm){ itm.selected = toggleStatus });
        }

        function approve() {
            var query = {};
            query['invoice_currency']   = vm.invoice.currency;
            query['invoice_id']      = vm.invoice.id;
            query['total_rate']      = vm.invoice.total_rate;
            InvoicesService.authorizeInvoicePayment(query).then(function(response) {
                $scope.$emit('ApproveInvoicePayment',{message:vm.invoice.id});
                toastr.success('Invoice Payment Authorized!');
                $uibModalInstance.close();
            });
        }

        function disapprove() {
            var query = {};
            query['invoice_currency']   = vm.invoice.currency;
            query['invoice_id']      = vm.invoice.id;
            query['total_rate']      = vm.invoice.total_rate;
            InvoicesService.unauthorizeInvoicePayment(query).then(function(response) {
                toastr.warning('Invoice Payment unauthorized!');
                $uibModalInstance.close();
            });
        }

        function cancel() {
            $uibModalInstance.close();
        }
    }

})();